// src/pages/Revenue.js
import React, { useState } from 'react';
import LineChart from '../components/charts/LineChart';

const Revenue = () => {
  const [filterType, setFilterType] = useState('all');
  const [sortBy, setSortBy] = useState('date');

  const lineData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Revenue ($)',
        data: [100, 300, 200, 400, 700, 500, 600],
        borderColor: '#ba00ba',
      },
    ],
  };

  const demoTransactions = [
    {
      description: 'Customer #128: Parking Fee',
      transactionId: '#12548800',
      type: 'parking',
      card: '**** 2222',
      date: '2025-01-29T14:15:00',
      amount: 4,
    },
    {
      description: 'Tip from Grace Hopper',
      transactionId: '#12548798',
      type: 'tips',
      card: '**** 1111',
      date: '2025-01-29T11:15:00',
      amount: 5,
    },
    {
      description: 'Tip from Alan Turing',
      transactionId: '#12548797',
      type: 'tips',
      card: '**** 9876',
      date: '2025-01-28T00:30:00',
      amount: 10,
    },
    {
      description: 'Customer #125: Parking Fee',
      transactionId: '#12548796',
      type: 'parking',
      card: '**** 1234',
      date: '2025-01-25T22:40:00',
      amount: 3,
    },
  ];

  const filteredTx = demoTransactions.filter((tx) => {
    if (filterType === 'all') return true;
    return tx.type === filterType;
  });

  filteredTx.sort((a, b) => {
    if (sortBy === 'date') {
      return new Date(b.date) - new Date(a.date);
    }
    return b.amount - a.amount;
  });

  const totalRevenue = demoTransactions.reduce((acc, tx) => acc + tx.amount, 0);
  const totalTips = demoTransactions
    .filter((tx) => tx.type === 'tips')
    .reduce((acc, tx) => acc + tx.amount, 0);
  const totalParking = demoTransactions
    .filter((tx) => tx.type === 'parking')
    .reduce((acc, tx) => acc + tx.amount, 0);

  return (
    <div style={{ padding: '20px' }}>
      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '30px',
      }}>
        {/* LEFT COLUMN: 2 TEXT ROWS */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div style={{
            background: '#fff',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          }}>
            <h3 style={{ marginBottom: '10px' }}>Total Revenue</h3>
            <p style={{ fontSize: '1.5rem' }}>${totalRevenue}</p>
            <span style={{ color: '#444' }}>Overall from tips + parking</span>
          </div>
          <div style={{
            display: 'flex',
            gap: '20px',
            width: '100%',
          }}>
            <div style={{
              flex: 1,
              background: '#fff',
              borderRadius: '8px',
              padding: '20px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}>
              <h3 style={{ marginBottom: '10px' }}>Total Tips</h3>
              <p style={{ fontSize: '1.5rem' }}>${totalTips}</p>
              <span style={{ color: '#444' }}>Across all valets</span>
            </div>
            <div style={{
              flex: 1,
              background: '#fff',
              borderRadius: '8px',
              padding: '20px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}>
              <h3 style={{ marginBottom: '10px' }}>Parking Fees</h3>
              <p style={{ fontSize: '1.5rem' }}>${totalParking}</p>
              <span style={{ color: '#444' }}>Parking revenue so far</span>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN: Weekly Revenue Trend */}
        <div style={{
          flex: 1,
          background: '#fff',
          borderRadius: '8px',
          padding: '20px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        }}>
          <h3 style={{ marginBottom: '10px' }}>Weekly Revenue Trend</h3>
          <div style={{ height: '280px' }}>
            <LineChart lineData={lineData} />
          </div>
        </div>
      </div>

      {/* TRANSACTIONS TABLE */}
      <div style={{
        background: '#fff',
        borderRadius: '8px',
        padding: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      }}>
        <h2 style={{ marginBottom: '10px' }}>Recent Transactions</h2>
        <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
          <button
            style={{
              background: filterType === 'all' ? '#ba00ba' : '#ddd',
              color: filterType === 'all' ? '#fff' : '#444',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
            onClick={() => setFilterType('all')}
          >
            All
          </button>
          <button
            style={{
              background: filterType === 'tips' ? '#ba00ba' : '#ddd',
              color: filterType === 'tips' ? '#fff' : '#444',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
            onClick={() => setFilterType('tips')}
          >
            Tips
          </button>
          <button
            style={{
              background: filterType === 'parking' ? '#ba00ba' : '#ddd',
              color: filterType === 'parking' ? '#fff' : '#444',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
            onClick={() => setFilterType('parking')}
          >
            Parking
          </button>
        </div>
        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
          <span style={{ fontWeight: 'bold', color: '#ba00ba' }}>Sort By:</span>
          <button
            style={{
              background: sortBy === 'date' ? '#ba00ba' : '#ddd',
              color: sortBy === 'date' ? '#fff' : '#444',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
            onClick={() => setSortBy('date')}
          >
            Date
          </button>
          <button
            style={{
              background: sortBy === 'amount' ? '#ba00ba' : '#ddd',
              color: sortBy === 'amount' ? '#fff' : '#444',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
            onClick={() => setSortBy('amount')}
          >
            Amount
          </button>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <th style={{ textAlign: 'left', padding: '8px' }}>Description</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Transaction ID</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Type</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Card</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Date</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Amount ($)</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Receipt</th>
            </tr>
          </thead>
          <tbody>
            {filteredTx.map((tx, idx) => {
              const dateStr = new Date(tx.date).toLocaleString();
              return (
                <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '8px' }}>{tx.description}</td>
                  <td style={{ padding: '8px' }}>{tx.transactionId}</td>
                  <td style={{ padding: '8px' }}>{tx.type}</td>
                  <td style={{ padding: '8px' }}>{tx.card}</td>
                  <td style={{ padding: '8px' }}>{dateStr}</td>
                  <td style={{ padding: '8px' }}>{tx.amount}</td>
                  <td style={{ padding: '8px' }}>
                    <button
                      style={{
                        padding: '6px 12px',
                        background: '#ba00ba',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                      }}
                    >
                      Download
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Revenue;
